/** Formats d’affichage — par société, pas de l’UI. */
export type CurrencyDisplay = "symbol" | "code";
export type DateFormat = "dmy";

export type CompanyFormats = {
  currency: "EUR";
  currency_display: CurrencyDisplay;
  decimal_comma: boolean;
  date_format: DateFormat;
  time_24h: boolean;
  fiscal_year_start: number;
};

export const DEFAULT_FORMATS: CompanyFormats = {
  currency: "EUR",
  currency_display: "symbol",
  decimal_comma: true,
  date_format: "dmy",
  time_24h: true,
  fiscal_year_start: 1,
};

function asBool(v: unknown, fallback: boolean): boolean {
  if (v == null) return fallback;
  if (typeof v === "boolean") return v;
  if (typeof v === "number") return v !== 0;
  if (v === "0" || v === "false") return false;
  return Boolean(v);
}

export function formatsFromCompany(row: {
  currency_display?: string | null;
  decimal_comma?: boolean | number | null;
  time_24h?: boolean | number | null;
  fiscal_year_start?: number | null;
} | null | undefined): CompanyFormats {
  const fy = Number(row?.fiscal_year_start ?? 1);
  return {
    currency: "EUR",
    currency_display: row?.currency_display === "code" ? "code" : "symbol",
    decimal_comma: asBool(row?.decimal_comma, true),
    date_format: "dmy",
    time_24h: asBool(row?.time_24h, true),
    fiscal_year_start: fy >= 1 && fy <= 12 ? fy : 1,
  };
}
